import React from "react";
import { render } from "storyblok-rich-text-react-renderer";
import rteResolver from "../../../utils/rteResolver";
import ResImg from "../../../components/resImg";
import ResVideo from "../../../components/resVideo";

const ImageWithText = (props) => {

    const blok = props.blok


    const hasVideo = blok.video?.filename != undefined && blok.video?.filename != ""

    const reverseOnDesktop = blok.reverse_on_desktop || false

    const useTwoColumns = blok.use_two_columns || false

    return (
        <section className="grid lg:grid-cols-2 relative gap-8 lg:gap-0 mt-[10rem] lg:mt-0">

            <div className="width-padding flex flex-col justify-end lg:justify-start lg:space-y-16">


                {blok.title != undefined && (
                    <h2 className="text-3xl lg:text-53 font-serif font-extralight lg:pt-72" dangerouslySetInnerHTML={{ __html: blok.title }}>
                    </h2>
                )}

                <div className={`${useTwoColumns ? `lg:grid-cols-2 gap-10 ` : `lg:grid-cols-1`} lg:ml-16 max-w-lg pb-20 hidden lg:grid`}>
                    {blok.left_copy != undefined && (<div className={`text-lg rte ${useTwoColumns ? `` : `unpad-last`}`}> {render(blok.left_copy, rteResolver)} </div>)}
                    {blok.right_copy != undefined && (<div className={`text-lg rte ${useTwoColumns ? `` : `unpad-last`}`}> {render(blok.right_copy, rteResolver)} </div>)}
                </div>

            </div>

            <div className={`${reverseOnDesktop ? `lg:order-first` : `lg:order-last`} h-full w-full relative`}>
            <div className={`lg:sticky lg:inset-0 w-full min-h-[500px] lg:min-h-[100vh] max-h-[115vh] overflow-hidden sticky-project-side`}>
                {
                        hasVideo ? (
                            <ResVideo mobileVideo={blok.mobile_video} desktopVideo={blok.video} mobilePoster={blok.mobile_image} desktopPoster={blok.image} className='w-full h-full object-cover min-h-[500px]  lg:min-h-[100vh] max-h-[115vh]' />
                        ) :
                        (
                            <ResImg mobile={blok.mobile_image} desktop={blok.image} critical={true} className='w-full h-full object-cover'/>
                        )
                }
            </div>
            </div>

            <div className="lg:hidden width-padding space-y-4">
                {blok.left_copy != undefined && (<div className="rte unpad-first"> {render(blok.left_copy, rteResolver)} </div>)}
                {blok.right_copy != undefined && (<div className="rte unpad-last"> {render(blok.right_copy, rteResolver)} </div>)}
            </div>


        </section>
    )
}

export default ImageWithText